// 出現演出（フェードイン）: <img data-mp-reveal> など
// 画面に入ったら .is-loaded を付ける。画像はデコード完了を待ってから表示する。
// [data-mp-reveal-group] の中の [data-mp-reveal] は個別に見ず、グループが画面に入ったら少しずつずらして順に表示する。
// JS が動いて演出できると分かったときだけ <html class="is-motion"> を付け、
// CSS はそのときだけ要素を隠す（JS が無い環境や reduced-motion では最初から見える）。

export const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
export const canAnimate = 'IntersectionObserver' in window && !reduceMotion;

/** 要素を表示する。画像はデコード後、delay(ms) を待ってから */
export function revealElement(element, delay = 0) {
  const done = () =>
    requestAnimationFrame(() => {
      if (delay > 0) element.style.transitionDelay = `${delay}ms`;
      element.classList.add('is-loaded');
      if (delay > 0) setTimeout(() => element.style.removeProperty('transition-delay'), delay + 1100);
    });
  if (!(element instanceof HTMLImageElement)) {
    done();
    return;
  }
  if (element.decode) element.decode().then(done).catch(done);
  else if (element.complete) done();
  else {
    element.addEventListener('load', done, { once: true });
    element.addEventListener('error', done, { once: true });
  }
}

/** 複数要素を step(ms) ずつずらして順に表示する */
export function revealSequence(elements, step = 65) {
  elements.forEach((element, index) => revealElement(element, index * step));
}

/** 画面に入ったら表示する IntersectionObserver を作る（すでに画面より上にある要素も対象） */
export function observeReveal(elements, onEnter, options = { threshold: 0.2 }) {
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting || entry.boundingClientRect.top < 0) {
        onEnter(entry.target);
        observer.unobserve(entry.target);
      }
    });
  }, options);
  elements.forEach((element) => observer.observe(element));
  return observer;
}

export function setupReveal() {
  const all = [...document.querySelectorAll('[data-mp-reveal]')];
  if (!canAnimate) {
    all.forEach((element) => revealElement(element));
    return;
  }
  document.documentElement.classList.add('is-motion');
  const groups = [...document.querySelectorAll('[data-mp-reveal-group]')];
  const targets = all.filter((element) => !element.parentElement.closest('[data-mp-reveal-group]'));
  observeReveal(targets, (element) => revealElement(element));
  observeReveal(groups, (group) => revealSequence([...group.querySelectorAll('[data-mp-reveal]')], 90), { threshold: 0.1 });
}
